var Handlebars = require("/home/travis/build/thelounge/lounge/node_modules/handlebars/runtime.js");
function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
module.exports = (Handlebars["default"] || Handlebars).template({"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    return "<div class=\"unread-marker\">\n	<span class=\"unread-marker-text\"></span>\n</div>\n";
},"useData":true});


//////////////////
// WEBPACK FOOTER
// ./client/views/unread_marker.tpl
// module id = 244
// module chunks = 0